module.exports = __webpack_public_path__ + "static/img/zgz.a62b1e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zgz.jpg
// module id = fgJ5
// module chunks = 2